import React from 'react'
import { PillIconPosition, PillVariant } from './type'
import cn from 'classnames'

interface PillIconProps {
  icon: React.ReactNode
  variant: PillVariant
  pillIconPosition: PillIconPosition
  testId?: string
  className?: string
  tabIndex?: number
}

const PillIcon: React.FC<PillIconProps> = (props) => {
  const { icon = <></>, variant = "label", testId = "pillIcon", pillIconPosition = "start", className, ...rest } = props;
  const iconWrapClassName = cn(`PillIcon PillIcon__${variant}--${pillIconPosition}`, `flex-center`, {
    [className]: !!className
  })

  return (
    <div {...rest} className={iconWrapClassName} data-test-id={testId}>
      {icon}
    </div>
  )
}

export default PillIcon
